"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Heading = _interopRequireDefault(require("../../elements/Heading/Heading"));
var _PageGrid = _interopRequireDefault(require("../../layouts/Skeletons/PageGrid/PageGrid"));
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _excluded = ["headingCopy", "subheadingCopy", "embedUrl", "embedTitle"];
var _templateObject, _templateObject2, _templateObject3;
var StyledSectionHeading = (0, _styledComponents.default)(function (_ref) {
  var className = _ref.className,
    children = _ref.children;
  return _react.default.createElement(_Heading.default, {
    h1: true,
    pink: true,
    className: className
  }, " ", children, " ");
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n"])));
var StyledSectionSubheading = (0, _styledComponents.default)(function (_ref2) {
  var className = _ref2.className,
    children = _ref2.children;
  return _react.default.createElement(_Heading.default, {
    hsub: true,
    gray: true,
    special: true,
    className: className
  }, " ", children, " ");
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n"])));
var StyledIframe = _styledComponents.default.iframe(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  border: none;\n  padding-top: 0px;\n\n  @media (min-width: ", ") {\n    width: 350px !important;\n    height: 615px;\n  }\n  \n  @media (min-width: ", ") {\n    width: 525px !important;\n  }\n\n  @media (min-width: ", ") {\n    width: 750px !important;\n    height: 650px;\n  }\n"])), _bfBaseStyles.Breakpoints.xs, _bfBaseStyles.Breakpoints.s, _bfBaseStyles.Breakpoints.m);
var ContactUsForm = function ContactUsForm(_ref3) {
  var headingCopy = _ref3.headingCopy,
    subheadingCopy = _ref3.subheadingCopy,
    embedUrl = _ref3.embedUrl,
    embedTitle = _ref3.embedTitle,
    props = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  return _react.default.createElement(_PageGrid.default, props, _react.default.createElement(StyledSectionHeading, null, " ", headingCopy, " "), _react.default.createElement(StyledSectionSubheading, null, " ", subheadingCopy, " "), _react.default.createElement(_Grid.default, Object.assign({
    container: true,
    justifyContent: "center"
  }, props), _react.default.createElement(StyledIframe, {
    src: embedUrl,
    title: embedTitle
  })));
};
var _default = ContactUsForm;
exports.default = _default;